import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Legal.scss';

const Terms = () => {
  return (
    <>
      <Header />
      <div className="legal-container">
        <div className="legal-content">
          <Link to="/" className="back-link">
            <FiArrowLeft size={20} />
            <span>Back to Home</span>
          </Link>

          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <div className="legal-section">
  <h2>1. Acceptance of Terms</h2>
  <p>
    By accessing and using INVITS ("the Service"), you accept and agree to be bound by these Terms and Conditions.
    INVITS is a digital invitations and community management platform owned and operated by <strong>Forte Technologies</strong>.
    If you do not agree to these terms, please do not use our Service.
  </p>
</div>

          <div className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              INVITS is a platform that allows users to create, manage, and share digital invitations for events. 
              Users can also create community pages, charge membership fees, and sell paid passes for events.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. User Accounts</h2>
            <h3>3.1 Registration</h3>
            <p>
              To use certain features of our Service, you must register for an account. You agree to provide accurate, 
              current, and complete information during registration and to update such information to keep it accurate.
            </p>
            
            <h3>3.2 Account Security</h3>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for all activities 
              that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
            
            <h3>3.3 Account Termination</h3>
            <p>
              We reserve the right to suspend or terminate your account if you violate these Terms, engage in fraudulent activities,
              or misuse the platform in any way. INVITS may also take legal action if required.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Payments, Commissions, and Refunds</h2>
            
            <h3>4.1 Organizers and Event Hosts</h3>
            <p>
              Organizers who create invitations and offer paid passes agree to pay the platform commission/fees as displayed 
              during invitation creation. By listing paid passes, the organizer acknowledges and accepts the platform fees.
            </p>

            <h3>4.2 Attendees and Users</h3>
            <p>
              Users purchasing paid passes or memberships agree to pay any applicable platform fees for each purchase.
            </p>

            <h3>4.3 Refunds</h3>
            <p>
              All refund requests must be directed to the event organizer or host. INVITS is not liable for any refunds, 
              disputes, or claims between organizers and attendees. Platform fees may not be refunded by INVITS.
            </p>

            <h3>4.4 Community Pages</h3>
            <p>
              Users may create community pages and charge membership fees. INVITS will take a commission on these transactions, 
              and by using the Service, users agree to these commissions.
            </p>

            <h3>4.5 Fraud and Misuse</h3>
            <p>
              If INVITS detects fraudulent activity or misuse of the platform, we reserve the right to terminate accounts 
              and may take legal action where necessary.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the Service for any illegal purposes or to violate any laws</li>
              <li>Post or transmit any content that is offensive, defamatory, or infringes on intellectual property rights</li>
              <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
              <li>Use automated systems or software to extract data from the Service</li>
              <li>Interfere with or disrupt the Service or servers or networks connected to the Service</li>
              <li>Impersonate any person or entity or misrepresent your affiliation with any person or entity</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. Content and Intellectual Property</h2>
            <h3>6.1 User Content</h3>
            <p>
              You retain ownership of content you create and share through the Service. By posting content, you grant 
              INVITS a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content 
              as necessary to provide the Service.
            </p>
            
            <h3>6.2 INVITS Intellectual Property</h3>
            <p>
              All rights, title, and interest in and to the Service, including all software, text, media files, and 
              other content available on the Service, are owned by INVITS or our licensors. You may not copy, modify, 
              distribute, sell, or lease any part of our Service without our prior written consent.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India. Any disputes 
              arising out of or relating to these Terms or the Service shall be subject to the exclusive jurisdiction 
              of the courts in Raipur, Chhattisgarh, India.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Material changes will be posted on our website 
              and the "Last Updated" date will be updated. Your continued use of the Service after such changes constitutes acceptance of the new Terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> suport@invits.co<br />
          
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Terms;
